export const MOBILE_BREAKPOINT = 992;
export const CHART_BREAKPOINT_SMALL = 400;
